import { render, staticRenderFns } from "./ordermsg.vue?vue&type=template&id=5c1f840e&scoped=true&"
import script from "./ordermsg.vue?vue&type=script&lang=js&"
export * from "./ordermsg.vue?vue&type=script&lang=js&"
import style0 from "./ordermsg.vue?vue&type=style&index=0&id=5c1f840e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1f840e",
  null
  
)

export default component.exports